export default `
query QueryInstances($propertyId: ID!, $from: Float, $to: Float, $after: ID) {
  queryInstancesByPropertyIdStartTimeIndex(propertyId: $propertyId, from: $from, to: $to, after: $after) {
    nextToken
    items {
      createdAt
      instanceId
    }
  }
}
`